module.exports = __webpack_public_path__ + "img/MTABAPPECG.0a032941.jpg";